import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var VALUES_REG = /,(?![^(]*\))/;
var PARTS_REG = /\s(?![^(]*\))/;
var LENGTH_REG = /^[0-9]+[a-zA-Z%]+?$/;

var parseValue = function parseValue(str) {
  var parts = str.split(PARTS_REG);
  var inset = parts.includes('inset');
  var last = parts.slice(-1)[0];
  var color = !isLength(last) ? last : undefined;
  var nums = parts.filter(function (n) {
    return n !== 'inset';
  }).filter(function (n) {
    return n !== color;
  }).map(toNum);

  var _nums = _slicedToArray(nums, 4),
      offsetX = _nums[0],
      offsetY = _nums[1],
      blurRadius = _nums[2],
      spreadRadius = _nums[3];

  return {
    inset: inset,
    offsetX: offsetX,
    offsetY: offsetY,
    blurRadius: blurRadius,
    spreadRadius: spreadRadius,
    color: color
  };
};

var stringifyValue = function stringifyValue(obj, multipler) {
  var _ref = obj || {},
      inset = _ref.inset,
      _ref$offsetX = _ref.offsetX,
      offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
      _ref$offsetY = _ref.offsetY,
      offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY,
      _ref$blurRadius = _ref.blurRadius,
      blurRadius = _ref$blurRadius === void 0 ? 0 : _ref$blurRadius,
      spreadRadius = _ref.spreadRadius,
      color = _ref.color;

  return [inset ? 'inset' : null, offsetX, offsetY, blurRadius, spreadRadius, color].filter(function (v) {
    return v !== null && v !== undefined;
  }).map(function (s) {
    return toVw(s, multipler);
  }).map(function (s) {
    return ('' + s).trim();
  }).join(' ');
};

var isLength = function isLength(v) {
  return v === '0' || LENGTH_REG.test(v);
};

var toNum = function toNum(v) {
  if (isNaN(+v)) return v;
  var n = parseFloat(v);
  return !isNaN(n) ? n : v;
};

var toVw = function toVw(n, multipler) {
  return typeof n === 'number' && n !== 0 ? multipler(n) : n;
};

export var parse = function parse(str) {
  return str.split(VALUES_REG).map(function (s) {
    return s.trim();
  }).map(parseValue);
};
export var stringify = function stringify(arr, multipler) {
  return arr.map(function (v) {
    return stringifyValue(v, multipler);
  }).join(', ');
};
export var isFluid = function isFluid(str) {
  return !!parse(str).find(function (s) {
    var _ref2 = s || {},
        _ref2$offsetX = _ref2.offsetX,
        offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX,
        _ref2$offsetY = _ref2.offsetY,
        offsetY = _ref2$offsetY === void 0 ? 0 : _ref2$offsetY,
        _ref2$blurRadius = _ref2.blurRadius,
        blurRadius = _ref2$blurRadius === void 0 ? 0 : _ref2$blurRadius,
        spreadRadius = _ref2.spreadRadius;

    return [offsetX, offsetY, blurRadius, spreadRadius].find(function (v) {
      return typeof v === 'number' && v !== 0;
    });
  });
};